/*
  PlusCards card behaviours (loaded from layout/theme.liquid)

  - [data-pc-notify-toggle]  reveal the restock email form on sold-out tiles
  - [data-pc-notify-form]    post the restock request to /contact

  Add-to-cart on the tiles goes through Spark's own quick-add delegate
  (data-quick-add on the button), so cart state and the drawer stay in sync.
*/
(function () {
  'use strict';

  function toggleNotify(btn) {
    var tile = btn.closest('[data-pc-tile]');
    if (!tile) return;
    var form = tile.querySelector('[data-pc-notify-form]');
    if (!form) return;
    var open = form.classList.toggle('active');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var input = form.querySelector('input[type="email"]');
      if (input) input.focus();
    }
  }

  function submitNotify(form) {
    var input = form.querySelector('input[type="email"]');
    if (!input || !input.value || !input.checkValidity()) {
      if (input) {
        input.reportValidity();
        input.focus();
      }
      return;
    }
    var tile = form.closest('[data-pc-tile]');
    var success = tile ? tile.querySelector('.pc-notify-success') : null;
    var toggle = tile ? tile.querySelector('[data-pc-notify-toggle]') : null;
    var title = form.getAttribute('data-product-title') || '';

    var data = new FormData();
    data.append('form_type', 'contact');
    data.append('utf8', '✓');
    data.append('contact[email]', input.value);
    data.append('contact[tags]', 'back-in-stock');
    data.append('contact[body]', 'Back in stock request for: ' + title);

    fetch('/contact', { method: 'POST', body: data }).catch(function () {});

    form.classList.remove('active');
    form.style.display = 'none';
    if (toggle) toggle.style.display = 'none';
    if (success) success.style.display = 'block';
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-pc-notify-toggle]');
    if (toggle) {
      e.preventDefault();
      toggleNotify(toggle);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-pc-notify-form]');
    if (!form) return;
    e.preventDefault();
    submitNotify(form);
  });
})();
